import { apiProvider } from "./core/provider";

const apiTour = {};

// Per-user product-tour first-view tracking (server-side, UserPreferences.TourFirstViews).
// tourKey is a stable string id per tour (e.g. "scheduler-calendar", "work-areas").
apiTour.getFirstView = function (tourKey) {
  return apiProvider.get(`users/tour-first-view?tour=${encodeURIComponent(tourKey)}`);
};

// Records the user's first view of a tour at server time, once, never overwriting.
apiTour.markFirstView = function (tourKey) {
  return apiProvider.post(`users/tour-first-view`, { tour: tourKey });
};

export { apiTour };